import { render, staticRenderFns } from "./rukuApply.vue?vue&type=template&id=68dfc6e1&scoped=true"
import script from "./rukuApply.vue?vue&type=script&lang=js"
export * from "./rukuApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dfc6e1",
  null
  
)

export default component.exports